import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from '../../services/events.service';
import { AuthTask } from '../../task-list/models/auth-task.model';

@Component({
  selector: 'app-decline-reason',
  templateUrl: './decline-reason.component.html',
  styleUrl: './decline-reason.component.scss'
})
export class DeclineReasonComponent implements OnInit {

  @Input() authTask: AuthTask;
  noteText: string = '';

  constructor(
    private activeModal: NgbActiveModal,
    private eventsService: EventsService
  ) {
  }

  ngOnInit() {
    this.eventsService.closeModal.subscribe(() => {
      this.close();
    });
  }

  clear(){
    this.noteText = '';
  }

  declineTask(){
    this.authTask.declinedReason = this.noteText;
    this.eventsService.declineTask.emit(this.authTask);
  }

  close(): void {
    this.activeModal.close();
  }
}
